export const calculateChipsShownNumber = (
  chipElements: React.RefObject<HTMLDivElement>[],
  containerElement: React.RefObject<HTMLDivElement>,
  isExpanded: boolean,
) => {
  if (!chipElements.length || !containerElement.current) return 0;

  const maxWidth = containerElement.current.offsetWidth;

  const additionalWidth = 8; /* chipElement left/right margin */

  const calculateReduceElements = (start: number, skipAdditionalChip = false) =>
    chipElements.slice(start).reduce(
      ({ items, totalWidth }, { current }) => {
        if (!current) return { items, totalWidth };

        // approximate width for the chip number of hidden chips
        const chipNumberLength = !skipAdditionalChip
          ? (chipElements.length - items > 9 ? 40 : 32) + additionalWidth
          : 0;

        // last item doesn't need ChipNumber length
        const calculatedMaxWidth =
          items === chipElements.length - start
            ? maxWidth
            : maxWidth - chipNumberLength;

        // Width for one chip and any additional width(paddings)
        const calculatedChipWidth =
          totalWidth + current.offsetWidth + additionalWidth;

        return {
          items: calculatedMaxWidth > calculatedChipWidth ? items + 1 : items,
          totalWidth: calculatedChipWidth,
        };
      },
      {
        items: 1,
        totalWidth: chipElements[start - 1].current
          ? (chipElements[start - 1].current?.offsetWidth || 0) +
            additionalWidth
          : 0,
      },
    );

  const firstRowValue = calculateReduceElements(1, isExpanded);

  let secondRowValue = { items: 0, totalWidth: 0 };

  if (
    isExpanded &&
    firstRowValue.totalWidth >= maxWidth &&
    chipElements[firstRowValue.items]?.current
  ) {
    secondRowValue = calculateReduceElements(firstRowValue.items + 1);
  }

  return firstRowValue.items + secondRowValue.items;
};
